"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    richtextLabel: {
      color: theme.palette.primary.main,
      display: "block",
      fontWeight: "bold",
      marginBottom: 8,
      marginTop: 16
    },
    root: {
      "& .fr-toolbar.fr-top": {
        borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0")
      },
      "& .second-toolbar": {
        borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px")
      },
      "& .fr-box.fr-basic": {
        borderRadius: theme.shape.borderRadius
      },
      "& .fr-wrapper .fr-placeholder": {
        color: theme.palette.text.secondary
      }
    }
  };
};

exports.styles = styles;